export default __webpack_public_path__ + "static/media/endDate.51b8d735.svg";